<template>
  <tr>
    <td>
      <a class="text-blue" :href="localeUrl('/ships/' + item.ship.id + '/')">
        {{ item.ship.name }}
      </a>
    </td>
    <td>
      <span>
        <span class="text-navy">{{ dateFromDDMM }} &ensp;</span>
        <span class="text-muted">{{ dateFromHHMM }}</span>
      </span>
    </td>
    <td>
      <span class="text-navy">{{ dateToDDMM }} &ensp;</span>
      <span class="text-muted">{{ dateToHHMM }}</span>
    </td>
    <td>
      <span class="text-navy" v-if="item.days">{{ item.days }}</span>
    </td>
    <td>
      <a :href="localeUrl('/river-cruises/' + item.id + '/')">
        <ul class="text-blue">
          <li v-for="(point, index) in item.routes_array" :key="index">
            {{ point }}
          </li>
        </ul>
      </a>
    </td>
    <td>
      <div class="d-flex flex-column">
        <span class="line-through text-gray" v-if="item.discount">
          {{ $rub((item.price_from * 100) / (100 - item.discount)) }}
        </span>
        <span class="text-yellow" v-if="item.price_from">
          {{ $rub(item.price_from) }}
        </span>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  name: "CruiseListViewTableTr.vue",
  props: ["item", "compare"],
  computed: {
    dateFromDDMM() {
      return this.$dateRaw(this.item.date_from).format("DD.MM");
    },
    dateFromHHMM() {
      return this.$dateRaw(this.item.date_from).format("HH:mm");
    },
    dateToDDMM() {
      return this.$dateRaw(this.item.date_to).format("DD.MM");
    },
    dateToHHMM() {
      return this.$dateRaw(this.item.date_to).format("HH:mm");
    },
  },
  methods: {
    updateCompare(cruiseId) {
      this.$store.commit("updateCompare", cruiseId);
    },
    localeUrl(url) {
      if (
        typeof window.transferState !== "undefined" &&
        window.transferState.get("i18n").locale !== "ru"
      ) {
        return (url = "/" + window.transferState.get("i18n").locale + url);
      }
      return url;
    },
  },
};
</script>

<style lang="scss">
.text-navy + .text-muted {
  margin-left: 5px;
}
</style>
